import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { EnumRoutes } from '@/helpers/enums/routes.enum';

/**
 * The "dashboard area" is the set of authenticated pages that share the
 * left side-nav layout (and, in the header, a centered search field with no
 * nav tabs): the dashboard and every page under it, My Courses, and My Grades.
 * These are exactly the destinations of the left side-nav items — "Explore
 * courses" (/lms/all-courses) is intentionally excluded, it keeps the classic
 * app-bar-with-tabs layout.
 *
 * Kept in a single composable so the two consumers never drift:
 *  - AppBar decides tabs-vs-search and where the mobile nav-icon points.
 *  - BasicLayout decides whether the side-nav renders and shifts <v-main>.
 */
export function useDashboardArea() {
  const route = useRoute();

  const isDashboardArea = computed(() => {
    const path = route.path === '/' ? window.location.pathname : route.path;
    return (
      path.startsWith(EnumRoutes.dashboard.root.path) ||
      route.name === EnumRoutes.lms.myCourses.name ||
      route.name === EnumRoutes.profile.myGrades.root.name
    );
  });

  return { isDashboardArea };
}
